import styled, { css, keyframes } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

interface TooltipProps {
  animStart?: boolean;
}

const ShakeKeyframe = keyframes`
  0% {
    transform: translate3d(-100%, 3px, 0);
  }
  50% {
    transform: translate3d(-100%, -3px, 0);
  }
  100% {
    transform: translate3d(-100%, 0, 0);
  }
`;

const ShakeKeyframeForMobile = keyframes`
  0% {
    transform: translate3d(-50%, 3px, 0);
  }
  50% {
    transform: translate3d(-50%, -3px, 0);
  }
  100% {
    transform: translate3d(-50%, 0, 0);
  }
`;

export const Contents = styled.div`
  position: relative;
  margin-top: 24px;
  padding: 40px 20px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 4px;
`;

export const RightCardHeaderWrapper = styled.div`
  position: relative;
`;

export const Tooltip = styled.div<TooltipProps>`
  position: absolute;
  top: 0;
  left: -10px;
  padding: 8px 16px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.magenta100};
  color: ${({ theme }) => theme.colors.magenta700};
  transform: translate3d(-100%, 0, 0);
  white-space: pre;
  text-align: center;
  z-index: 10;
  ${getFontStyle('midium150_C1')};

  ${({ theme }) => theme.media.mobile} {
    top: auto;
    bottom: -67px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: -8px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 8px solid ${({ theme }) => theme.colors.magenta100};
    transform: translate3d(0, -50%, 0);

    ${({ theme }) => theme.media.mobile} {
      top: -14px;
      right: auto;
      left: 50%;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 8px solid ${({ theme }) => theme.colors.magenta100};
      transform: translate3d(-50%, 0, 0);
    }
  }

  ${({ animStart, theme }) =>
    animStart &&
    css`
      animation: ${ShakeKeyframe} 150ms 2 linear;
      animation-delay: 500ms;

      ${theme.media.mobile} {
        animation-name: ${ShakeKeyframeForMobile};
      }
    `}
`;

export const BreakLineOnlyMobile = styled.span`
  ${({ theme }) => theme.media.mobile} {
    display: block;
  }
`;

export const ButtonWriteWrapper = styled.div`
  margin-right: 6px;

  > svg {
    vertical-align: top;
  }
`;
